import React from "react";
import { Outlet } from "react-router-dom";
import SidebarRegion from "../components/region/SidebarRegion";

export default function RegionLayout() {
  return (
    <div className="d-flex flex-column flex-lg-row" style={{ minHeight: "100vh" }}>
      <SidebarRegion />
      <main className="flex-grow-1 p-3">
        <div className="d-lg-none" style={{ height: "60px" }}></div>
        <Outlet />
      </main>
    </div>
  );
}
